import { format } from 'date-fns';
import { parseDateOnlyLocal } from '@erp/shared-utils';

export function formatFilesReadyDate(
  filesReadyAt: string | null,
  emptyLabel = '—',
): string {
  if (filesReadyAt === null || filesReadyAt === '') return emptyLabel;
  const date = parseDateOnlyLocal(filesReadyAt);
  if (date === null) return filesReadyAt;
  return date.toLocaleDateString(undefined, { dateStyle: 'medium' });
}

export function filesReadyDateValue(
  filesReadyAt: string | null,
): Date | undefined {
  if (filesReadyAt === null || filesReadyAt === '') return undefined;
  return parseDateOnlyLocal(filesReadyAt) ?? undefined;
}

export function canPersistFilesReady(params: {
  caseId: string | undefined;
  dateInputValid: boolean;
}): boolean {
  return params.caseId !== undefined && params.dateInputValid;
}

export function filesReadySaveDisabled(
  isPending: boolean,
  dateInputValid: boolean,
): boolean {
  return isPending || !dateInputValid;
}

export function formatFollowUpDate(value: string): string {
  const at = new Date(value);
  if (Number.isNaN(at.getTime())) return value;
  return format(at, 'MMM d, yyyy · h:mm a');
}

export function formatPricelistCaseAuditValue(
  field: string,
  value: unknown,
  emptyLabel: string,
  waitingOnLabel: (key: string) => string | null,
): string {
  if (typeof value === 'string' && value !== '') {
    if (field === 'waiting_on_key') return waitingOnLabel(value) ?? value;
    if (field === 'follow_up_at') return formatFollowUpDate(value);
    if (field === 'files_ready_at') return formatFilesReadyDate(value, value);
    return value;
  }
  if (value === null || value === undefined || value === '') return emptyLabel;
  if (typeof value === 'boolean' || typeof value === 'number') {
    return String(value);
  }
  return JSON.stringify(value);
}

/**
 * A `vendor_numbers` audit value (GEN-3074): "55317 / 61500". An empty array
 * is not "nothing" — it means every vendor# of the case's vendors — so it
 * reads `allLabel`; only a missing value reads `emptyLabel`.
 */
export function formatPricelistCaseVendorNumbersAuditValue(
  value: unknown,
  emptyLabel: string,
  allLabel: string,
): string {
  if (!Array.isArray(value)) return emptyLabel;
  if (value.length === 0) return allLabel;
  return value.map(String).join(' / ');
}
